import {
  ContractService,
  vsServiceName as ContractServiceName,
} from "../../../../Contract/shared/ContractService";
import {
  FormViewConfig,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";

import {
  vsServiceName as ContractInstanceFieldsServiceName,
  ContractInstanceFieldsService,
} from "../../../../Contract/shared/forms/contractInstanceFields";

import { IFieldArray } from "AngularFormly";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../../records/grids/columns/columnDefinitionSetService";

import { vsObjectName as contractInstanceName } from "../../../../Contract/shared/configs/contractInstance";

GamingContractMasterAgreementConfig.$inject = [
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
];

export const vsObjectName = "masterAgreement";

export function GamingContractMasterAgreementConfig(
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureForm(formViewServiceProvider);
  configureGrid(recordGridViewServiceProvider);
}

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      columnDefinitionService: ColumnDefinitionService,
      columnDefinitionSetService: ColumnDefinitionSetService
    ) => {
      return {
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/contract/masterAgreement"
        ),
        defaultSort: "Id",
        nameSingular: "Master Agreement",
        showAddButton: true,
        showAddButtonPermission: ["contractEdit", "contractSensitiveInfo"],
        gridSettings: gridSettingsService.getGridSettings(
          Symbol("contract.type.gamingcontractmasteragreement")
        ),
        columns: [
          ...columnDefinitionSetService.getColumnDefinitionSet(
            contractInstanceName
          ),
          columnDefinitionService.getStringColDef({
            field: "ContractMachineManufacturerName",
            header: "Manufacturer",
          }),
        ],
      };
    },
  ]);
}

function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    ContractServiceName,
    ContractInstanceFieldsServiceName,
    (
      contractService: ContractService,
      contractInstanceFieldsService: ContractInstanceFieldsService
    ) => {
      const contractType = contractService.getContractType(vsObjectName)!;

      const formFields: IFieldArray = [
        ...contractInstanceFieldsService.contractInstanceFields(),
        ...contractInstanceFieldsService.contractInstanceContactField(),
        ...contractInstanceFieldsService.contractInstanceFileFields(),
      ];

      const config: FormViewConfig = {
        fields: formFields,
        name: vsObjectName,
        title: (model) =>
          model.Id
            ? `Edit ${contractType.name}`
            : `Create ${contractType.name}`,
        submitForm: (args) => {
          return contractType
            .submitContract(<any>args.model, args.formViewController)
            .then((result) => {
              contractType.infoNavigate(result.ContractInstanceId);
            });
        },
      };

      return config;
    },
  ]);
}
